module.exports = __webpack_public_path__ + "static/quote@2x-39d578091348dbe7f91ddb17ff4bede4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/yieldr/quote@2x.jpg
// module id = 432
// module chunks = 3627797113349 20562973939449 33019919093843